"use client"

import React from "react";
import RegisterProviderProfile from "../Providers/RegisterProviderProfile";

const ProductsProviderSignUp = () => {
    return <RegisterProviderProfile providerType="products" />;
};

export default ProductsProviderSignUp
